export const SET_APP_SETTINGS = 'SET_APP_SETTINGS';
